import React from "react";
import style from "./Footer.module.css";
import { Typography } from "@mui/material";

function Footer() {

  return (
    <footer className={style.footer} style={{
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      borderTop: '1px solid rgba(255,255,255,0.2)'
    }}>
      <Typography component={"a"} href={"https://suitt.edu.ua/"} target={"_blank"} rel={"noreferrer"} variant={"body2"} textAlign={"center"} color={"white"} sx={{
        padding: '8px 0',
        display: 'inline-block',
        textDecoration: 'none'
      }}>
        {`Державний університет інтелектуальних технологій і зв'язку © ${new Date().getFullYear()}`}
      </Typography>
    </footer>
  );
}

export default Footer;
